export const STATUS_FILTER_VALUES = {
  ONLY_ACTIVE: 'only_active',
  ONLY_NON_ATTENDABLE: 'only_non_attendable',
} as const
